module.exports = __webpack_public_path__ + "img/results-hierarchy.314c446c.png";